import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { css } from 'emotion';
import sampleSize from 'lodash/sampleSize';
import shuffle from 'lodash/shuffle';
import { getLocalText } from './language';
var typeCheckerFn = function typeCheckerFn(key) {
  return function (q) {
    return q && q.type === key;
  };
};
export var typeChecker = {
  isSingleSelectChoice: function isSingleSelectChoice(q) {
    return /singleSelect/i.test(q === null || q === void 0 ? void 0 : q.type);
  },
  isSingleChoice: function isSingleChoice(q) {
    return ['nonScoreSingle', 'single'].includes(q === null || q === void 0 ? void 0 : q.type);
  },
  isMultiChoice: function isMultiChoice(q) {
    return ['multi', 'nonScoreMulti'].includes(q === null || q === void 0 ? void 0 : q.type);
  },
  isPageBreak: typeCheckerFn('page_break'),
  isDescription: typeCheckerFn('description'),
  isLongText: function isLongText(q) {
    return /long/i.test(q === null || q === void 0 ? void 0 : q.type);
  },
  isShortText: function isShortText(q) {
    return /short/i.test(q === null || q === void 0 ? void 0 : q.type);
  },
  isScale: typeCheckerFn('scale'),
  isMatrix: typeCheckerFn('matrix'),
  isLocation: typeCheckerFn('location'),
  isChoice: function isChoice(q) {
    return typeChecker.isSingleChoice(q) || typeChecker.isMultiChoice(q) || typeChecker.isSingleSelectChoice(q) || typeChecker.isLocation(q);
  },
  isText: function isText(q) {
    return typeChecker.isShortText(q) || typeChecker.isLongText(q);
  }
};
var breakpoints = {
  large: 1030,
  scale: 875,
  medium: 800
};
var globalSampleGids = {};
var _ref = "@media (";
var _ref2 = "){";
var _ref3 = ";}";
export var mq = Object.keys(breakpoints).reduce(function (accumulator, label) {
  var prefix = typeof breakpoints[label] === 'string' ? '' : 'min-width:';
  var suffix = typeof breakpoints[label] === 'string' ? '' : 'px';
  accumulator[label] = function (cls, simulateMobile) {
    if (simulateMobile) return '';
    return /*#__PURE__*/css(_ref, prefix + breakpoints[label] + suffix, _ref2, cls, _ref3);
  };
  return accumulator;
}, {});
var getQuotaText = function getQuotaText(quotaStrategy, opt) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  var basicOptText = mode === 'default' ? opt.text : opt.enText || 'Option';
  var quota = quotaStrategy.optionsQuota.find(function (q) {
    return q.id === opt.id;
  });
  if (!quota) return basicOptText;
  var prefix = '';
  if (quota.remaining) {
    prefix = '['.concat(quotaStrategy.showRemaining ? quotaStrategy.remainTips + quota.remaining : '', quotaStrategy.showAll ? "/".concat(quota.amount) : '', '] ');
  } else {
    prefix = '['.concat(quotaStrategy.fullTips, '] ');
  }
  return prefix + basicOptText;
};

// 先检查本题选项的显示逻辑 然后根据选项引用增加新的选项
export function getRealShowOption(_ref4) {
  var question = _ref4.question,
    answers = _ref4.answers,
    quotaStrategy = _ref4.quotaStrategy;
  var _question$custom = question.custom,
    options = _question$custom.options,
    group = _question$custom.group,
    optionGroups = _question$custom.optionGroups;
  var opts = group && (optionGroups === null || optionGroups === void 0 ? void 0 : optionGroups.length) ? sampleOptions({
    question: question,
    answers: answers
  }) : options;
  var realShowOptions = (opts || []).map(function (opt) {
    return _objectSpread({}, opt, {
      text: quotaStrategy ? getQuotaText(quotaStrategy, opt) : opt.text,
      enText: quotaStrategy ? getQuotaText(quotaStrategy, opt, 'en') : opt.enText || 'Option'
    });
  }).filter(function (el) {
    return checkDepRule({
      answers: answers,
      dep: el.dep
    }) && el.isShow !== false;
  });
  var _question$optionFilte = question.optionFilter,
    optionFilter = _question$optionFilte === void 0 ? [] : _question$optionFilte;
  optionFilter.forEach(function (opt) {
    var _targetQuestion$custo, _answers$filterByQues4;
    var _opt$id$split = opt.id.split('--matrix--'),
      _opt$id$split2 = _slicedToArray(_opt$id$split, 2),
      filterByQuestionId = _opt$id$split2[0],
      lineId = _opt$id$split2[1];
    var realLineId = lineId;
    var thatQuestionSelectedOptionsIds = answers[filterByQuestionId] ? answers[filterByQuestionId].selected : [];
    if (lineId) {
      if (lineId.indexOf('title') > -1) {
        realLineId = lineId.slice(0, -6);
      } else {
        thatQuestionSelectedOptionsIds = thatQuestionSelectedOptionsIds[realLineId] || [];
      }
    }
    var targetQuestion = (window.allQuestions || []).find(function (el) {
      return el.id === filterByQuestionId;
    });
    var targetOptions = [];
    if (lineId && lineId.indexOf('title') > -1) {
      targetOptions = targetQuestion ? targetQuestion.custom.lines : [];
      realShowOptions = _toConsumableArray(realShowOptions).concat(_toConsumableArray(targetOptions.filter(function (el) {
        return Object.keys(thatQuestionSelectedOptionsIds).length && thatQuestionSelectedOptionsIds[el.id] && el.id == realLineId;
      }).map(function (el) {
        return el;
      })));
    } else {
      targetOptions = targetQuestion ? targetQuestion.custom.realShowOptions || targetQuestion.custom.options : [];
      var existedOptIds = realShowOptions.map(function (el) {
        return el.id;
      });
      realShowOptions = _toConsumableArray(realShowOptions).concat(_toConsumableArray(targetOptions.filter(function (el) {
        return (thatQuestionSelectedOptionsIds || []).includes(el.id) && !existedOptIds.includes(el.id);
      }).map(function (el) {
        if (el.input) {
          var _answers$filterByQues, _answers$filterByQues2, _answers$filterByQues3;
          // "其他"选项填空，引用的时候引用填入的文本
          var userInput = (_answers$filterByQues = answers[filterByQuestionId]) === null || _answers$filterByQues === void 0 ? void 0 : (_answers$filterByQues2 = _answers$filterByQues.option_blank) === null || _answers$filterByQues2 === void 0 ? void 0 : (_answers$filterByQues3 = _answers$filterByQues2[el.id]) === null || _answers$filterByQues3 === void 0 ? void 0 : _answers$filterByQues3[0];
          return _defineProperty({
            id: el.id,
            isTrap: false,
            jumpId: '-1',
            text: !window.showMultiLang && userInput ? "".concat(el.text, " - ").concat(userInput) : el.text
          }, "".concat(window.language, "Text"), window.showMultiLang && userInput ? "".concat(el === null || el === void 0 ? void 0 : el["".concat(window.language, "Text")], " - ").concat(userInput) : el === null || el === void 0 ? void 0 : el["".concat(window.language, "Text")]);
        }
        return el;
      })));
    }
    if ((targetQuestion === null || targetQuestion === void 0 ? void 0 : (_targetQuestion$custo = targetQuestion.custom.other) === null || _targetQuestion$custo === void 0 ? void 0 : _targetQuestion$custo.status) && (((_answers$filterByQues4 = answers[filterByQuestionId]) === null || _answers$filterByQues4 === void 0 ? void 0 : _answers$filterByQues4.selected) || []).includes('other')) {
      var _answers$filterByQues5;
      // 老版“其他”
      var userInput = (_answers$filterByQues5 = answers[filterByQuestionId]) === null || _answers$filterByQues5 === void 0 ? void 0 : _answers$filterByQues5.text;
      realShowOptions.push({
        id: 'other',
        isTrap: false,
        jumpId: '-1',
        text: !window.showEnQuest && userInput ? "".concat(getLocalText('placeholder.other'), " - ").concat(userInput) : getLocalText('placeholder.other'),
        enText: window.showEnQuest && userInput ? "".concat(getLocalText('placeholder.other'), " - ").concat(userInput) : getLocalText('placeholder.other')
      });
    }
  });
  return realShowOptions;
}
// matrix题目 获取实际显示的题目
export function getRealShowLine(_ref6) {
  var question = _ref6.question,
    answers = _ref6.answers;
  var realShowLines = (question.custom.lines || []).filter(function (el) {
    return checkDepRule({
      answers: answers,
      dep: el.dep
    });
  });
  return realShowLines;
}
export function checkDepRule(_ref7) {
  var _ref7$answers = _ref7.answers,
    answers = _ref7$answers === void 0 ? {} : _ref7$answers,
    dep = _ref7.dep;
  // 如果没有依赖规则
  if (!dep || !dep.cons || !dep.cons.length) return true;
  // 显示依赖可能有多个
  var _loop = function _loop(i) {
    var con = dep.cons[i];
    if (!con.id) return "continue";
    // 由于matrix子题目的存在 依赖的部分包含questionId 和 子题目lineId
    var _con$id$split = con.id.split('--matrix--'),
      _con$id$split2 = _slicedToArray(_con$id$split, 2),
      depQuestionId = _con$id$split2[0],
      lineId = _con$id$split2[1];
    if (lineId && lineId.indexOf('title') > -1) {
      lineId = lineId.slice(0, -6);
    }
    // 判断当前依赖的这一题是否可见
    var q = (window.allQuestions || []).find(function (q) {
      return q.id === depQuestionId;
    });
    // 如果依赖的题目不可见
    if (!q || !answers[depQuestionId]) {
      // 如果约束类型是and,而依赖的题目不可见 则无法满足and的条件.
      if (dep.type === 'and') return {
        v: false
      };
      // 约束类型是or，看下一个。
      return "continue";
    }
    // if 后 是可以找到依赖题目的case
    // 取得用户的答案selected数组, 不同题型的答案存在不同的数据结构中
    var selectedIds = void 0;
    if (q.type === 'scale') {
      selectedIds = answers[q.id] && answers[q.id].degree ? [answers[q.id].degree] : [];
    } else if (q.type === 'matrix') {
      selectedIds = answers[q.id] && answers[q.id].selected[lineId] || [];
    } else if (q.type === 'location') {
      selectedIds = answers[q.id] && answers[q.id].location ? [answers[q.id].location.join('/')] : [];
    } else {
      selectedIds = answers[q.id] && answers[q.id].selected || [];
    }
    var isOK = void 0;
    if (con.checked) {
      // 显示当前题目的要求是 选择了 '之一' optionsIds中的选项
      if (con.type !== 'all') {
        isOK = selectedIds.some(function (id) {
          return con.optionIds.includes(id);
        });
      } else {
        // 选择了'全部' optionsIds中的选项
        isOK = (con.optionIds || []).every(function (id) {
          return selectedIds.includes(id);
        });
      }
    } else {
      // location题型
      isOK = selectedIds.every(function (id) {
        return !con.optionIds.includes(id);
      });
    }
    // 旧版问卷没有selected 字段, 新版增加了selected 覆盖旧版的逻辑 当selected为true时和旧版一样
    if (con.selected === false) {
      if (con.type === 'all') {
        isOK = !con.optionIds.every(function (id) {
          return selectedIds.includes(id);
        });
      } else if (con.type === 'any') {
        // optionsIds中的全部 都没有选择
        isOK = con.optionIds.every(function (id) {
          return !selectedIds.includes(id);
        });
      } else {
        isOK = con.optionIds.some(function (id) {
          return !selectedIds.includes(id);
        });
      }
    }
    // 如果当前依赖满足且约束类型是or
    if (isOK && dep.type === 'or') {
      return {
        v: true
      };
    }
    // 如果当前依赖未满足，且约束类型是and
    if (!isOK && dep.type === 'and') {
      return {
        v: false
      };
    }
  };
  for (var i = 0; i < dep.cons.length; i++) {
    var _ret = _loop(i);
    switch (_ret) {
      case "continue":
        continue;
      default:
        if (_typeof(_ret) === "object") return _ret.v;
    }
  }
  // 如果运行到这里了，只有两种情况：
  // 1. 约束类型是and且所有的依赖都满足（应当返回true
  // 2. 约束类型是or且所有依赖都未满足 (应当返回false
  return dep.type === 'and';
}
export var questionFilter = function () {
  // 被展示过的题目
  var visibles = [];
  function checkJumpOver(_ref8) {
    var _answers$q$id$selecte;
    var _ref8$answers = _ref8.answers,
      answers = _ref8$answers === void 0 ? {} : _ref8$answers,
      questions = _ref8.questions,
      question = _ref8.question;
    // 如果离得最近可见的选择/量表没有跳过它，那么前面的选择/量表也不可能跳过它。
    var typeList = visibles.map(function (q) {
      return q.type;
    });
    // 只有选择/量表有跳到哪的逻辑
    var index = Math.max(typeList.lastIndexOf('single'), typeList.lastIndexOf('nonScoreSingle'), typeList.lastIndexOf('singleSelect'), typeList.lastIndexOf('nonScoreSingleSelect'), typeList.lastIndexOf('multi'), typeList.lastIndexOf('nonScoreMulti'), typeList.lastIndexOf('scale'));
    // 前面根本不存在选择/量表
    if (index === -1) return false;
    var q = visibles[index];
    var selectedId;
    switch (q.type) {
      // 多选跳转逻辑
      case 'multi':
        {
          var _ret2 = function (_answers$q$id) {
            var selectedIds = (_answers$q$id = answers[q.id]) === null || _answers$q$id === void 0 ? void 0 : _answers$q$id.selected;
            if (!(selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.length)) return {
              v: false
            };
            var multiJumpRules = q.multiJumpRules;
            if (!(multiJumpRules === null || multiJumpRules === void 0 ? void 0 : multiJumpRules.length)) return {
              v: false
            };
            var qIndex = questions.findIndex(function (q) {
              return q.id === question.id;
            });

            // optionIds: 选项匹配，counts: 个数匹配
            var mode = multiJumpRules[0].logic ? 'counts' : 'optionIds';
            if (mode === 'optionIds') {
              var _loop2 = function _loop2(i) {
                var _multiJumpRules$i = multiJumpRules[i],
                  optionIds = _multiJumpRules$i.optionIds,
                  jumpId = _multiJumpRules$i.jumpId;
                if (jumpId === undefined || jumpId === '-1') return "continue";
                // 判断选中的选项完全和跳转逻辑一致
                var allSame = optionIds.length === selectedIds.length && optionIds.every(function (id) {
                  return selectedIds.includes(id);
                });
                if (!allSame) return "continue";
                var jumpIndex = questions.findIndex(function (q) {
                  return q.id === jumpId;
                });
                if (jumpId === 'end' || jumpIndex > qIndex) return {
                  v: {
                    v: true
                  }
                };
              };
              for (var i = 0; i < multiJumpRules.length; i++) {
                var _ret3 = _loop2(i);
                switch (_ret3) {
                  case "continue":
                    continue;
                  default:
                    if (_typeof(_ret3) === "object") return _ret3.v;
                }
              }
            } else {
              var _loop3 = function _loop3(i) {
                var _multiJumpRules$i2 = multiJumpRules[i],
                  _multiJumpRules$i2$co = _multiJumpRules$i2.count,
                  count = _multiJumpRules$i2$co === void 0 ? 0 : _multiJumpRules$i2$co,
                  logic = _multiJumpRules$i2.logic,
                  jumpId = _multiJumpRules$i2.jumpId;
                if (jumpId === undefined || jumpId === '-1') return "continue";
                var selectedIdsLength = selectedIds.length;
                var jumpIndex = questions.findIndex(function (q) {
                  return q.id === jumpId;
                });
                // 判断符合一条就返回
                var match = false;
                if (logic === '<' && selectedIdsLength < count) {
                  match = true;
                } else if (logic === '>' && selectedIdsLength > count) {
                  match = true;
                } else if (logic === '=' && selectedIdsLength === count) {
                  match = true;
                }
                if (match && (jumpId === 'end' || jumpIndex > qIndex)) return {
                  v: {
                    v: true
                  }
                };
              };
              for (var i = 0; i < multiJumpRules.length; i++) {
                var _ret4 = _loop3(i);
                switch (_ret4) {
                  case "continue":
                    continue;
                  default:
                    if (_typeof(_ret4) === "object") return _ret4.v;
                }
              }
            }
            return {
              v: false
            };
          }();
          if (_typeof(_ret2) === "object") return _ret2.v;
        }
      case 'scale':
        selectedId = answers[q.id] && answers[q.id].degree;
        break;
      default:
        // single & singleSelect
        selectedId = answers[q.id] && ((_answers$q$id$selecte = answers[q.id].selected) === null || _answers$q$id$selecte === void 0 ? void 0 : _answers$q$id$selecte[0]);
        break;
    }
    if (!selectedId) return false;
    var custom = q.custom;
    var option = selectedId === 'other' ? custom.other : (custom.options || []).find(function (o) {
      return o.id === selectedId;
    });
    if (!option) return false;
    // 如果选择的是其他，但是其他却没有呈现，Impossible！
    if (option.status === 0) return false;
    // 如果当前题目没有跳
    if (option.jumpId === undefined || option.jumpId === '-1') return false;
    // 判断是否跳过去了
    var qIndex = questions.findIndex(function (q) {
      return q.id === question.id;
    });
    var jumpIndex = questions.findIndex(function (q) {
      return q.id === option.jumpId;
    });
    if (option.jumpId === 'end' || option.jumpId === 'nextEnd' || jumpIndex > qIndex) return true;
    return false;
  }
  function checkNextEnd(_ref9) {
    var _answers$q$id$selecte2;
    var _ref9$answers = _ref9.answers,
      answers = _ref9$answers === void 0 ? {} : _ref9$answers;
    // 如果离得最近可见的选择/量表没有跳过它，那么前面的选择/量表也不可能跳过它。
    var typeList = visibles.map(function (q) {
      return q.type;
    });
    // 只有选择/量表有跳到哪的逻辑
    var index = Math.max(typeList.lastIndexOf('single'), typeList.lastIndexOf('nonScoreSingle'), typeList.lastIndexOf('singleSelect'), typeList.lastIndexOf('nonScoreSingleSelect'), typeList.lastIndexOf('multi'), typeList.lastIndexOf('nonScoreMulti'), typeList.lastIndexOf('scale'));
    // 前面根本不存在选择/量表
    if (index === -1) return false;
    var q = visibles[index];
    var selectedId;
    switch (q.type) {
      case 'scale':
        selectedId = answers[q.id] && answers[q.id].degree;
        break;
      default:
        // single & singleSelect
        selectedId = answers[q.id] && ((_answers$q$id$selecte2 = answers[q.id].selected) === null || _answers$q$id$selecte2 === void 0 ? void 0 : _answers$q$id$selecte2[0]);
        break;
    }
    if (!selectedId) return false;
    var custom = q.custom;
    var option = selectedId === 'other' ? custom.other : (custom.options || []).find(function (o) {
      return o.id === selectedId;
    });
    if (!option) return false;
    if (option.jumpId === 'nextEnd') return true;
    return false;
  }
  return function (questions, answers, sampleConfig, answerKeys) {
    var _sampleConfig$sampleB;
    visibles = [];
    var sampleGids = {};
    if (sampleConfig === null || sampleConfig === void 0 ? void 0 : (_sampleConfig$sampleB = sampleConfig.sampleByGroup) === null || _sampleConfig$sampleB === void 0 ? void 0 : _sampleConfig$sampleB.length) {
      sampleGids = sampleGroups({
        answers: answers,
        sampleConfig: sampleConfig
      });
      if (!Object.keys(globalSampleGids).length) {
        globalSampleGids = sampleGids;
      }
    }
    for (var i = 0; i < questions.length; i++) {
      var question = questions[i];
      // 如果是分页符号
      if (typeChecker.isPageBreak(question)) {
        // report不需要分页
        if (i && window.isReport) continue;
        // 如果分页符没有与前面重复，则push到visibles中去。
        if (!typeChecker.isPageBreak(visibles[visibles.length - 1])) {
          visibles.push(question);
        } else {
          // 这个逻辑是为了显示正确的分页描述
          visibles.pop();
          visibles.push(question);
        }
        continue;
      }
      // 检查是否被跳过
      if (checkJumpOver({
        answers: answers,
        questions: questions,
        question: question
      })) {
        if (!window.isReport && (answers === null || answers === void 0 ? void 0 : answers[question.id])) {
          delete answers[question.id];
        }
        continue;
      }

      // 判断显示依赖
      var groupIndex = question.groupIndex,
        sampleGroupIndex = question.sampleGroupIndex; // 如果是在题目组中，走checkGroupDepRule逻辑
      if (groupIndex !== undefined && groupIndex !== null) {
        if (checkGroupDepRule({
          answers: answers,
          sampleConfig: sampleConfig,
          groupIndex: groupIndex,
          sampleGroupIndex: sampleGroupIndex,
          answerKeys: answerKeys,
          sampleGids: sampleGids
        }) && checkDepRule({
          answers: answers,
          dep: question.dep
        })) {
          visibles.push(question);
        } else if (!window.isReport && (answers === null || answers === void 0 ? void 0 : answers[question.id])) {
          delete answers[question.id];
        }
      } else if (checkDepRule({
        answers: answers,
        dep: question.dep
      })) {
        // 依赖没问题，可以显示！
        visibles.push(question);
      } else if (!window.isReport && (answers === null || answers === void 0 ? void 0 : answers[question.id])) {
        delete answers[question.id];
      }
    }
    return {
      visibles: visibles,
      isNextEnd: checkNextEnd({
        answers: answers
      }),
      globalSampleGids: globalSampleGids
    };
  };
}();
export function getSampleGroupIds(_ref10) {
  var _ref10$depGroups = _ref10.depGroups,
    depGroups = _ref10$depGroups === void 0 ? [] : _ref10$depGroups,
    groupConfig = _ref10.groupConfig;
  var sampleIds = [];
  var beginGroup = groupConfig.beginGroup,
    endGroup = groupConfig.endGroup,
    groupCount = groupConfig.groupCount,
    isShuffle = groupConfig.shuffle;
  var depOptions = depGroups.slice(beginGroup, endGroup + 1);
  var trueList = depOptions.filter(function (item) {
    return item.status === true;
  });
  if (trueList.length > 0) {
    var groups = trueList.length > groupCount ? sampleSize(trueList, groupCount) : trueList;
    sampleIds = groups.map(function (g) {
      return g.index;
    }).sort(function (a, b) {
      return a - b;
    });
    if (isShuffle) {
      sampleIds = shuffle(sampleIds);
    }
  }
  return sampleIds;
}
export function sampleGroups(_ref11) {
  var answers = _ref11.answers,
    sampleConfig = _ref11.sampleConfig;
  var _sampleConfig$sampleB2 = sampleConfig.sampleByQuestion,
    sampleByQuestion = _sampleConfig$sampleB2 === void 0 ? [] : _sampleConfig$sampleB2,
    _sampleConfig$sampleB3 = sampleConfig.sampleByGroup,
    sampleByGroup = _sampleConfig$sampleB3 === void 0 ? [] : _sampleConfig$sampleB3;
  var sampleGroupIds = {};
  // 获取组题目随机后的索引

  if (sampleByGroup.length) {
    var depGroups = getDepGroups({
      answers: answers,
      sampleByQuestion: sampleByQuestion
    });
    sampleByGroup.forEach(function (groupConfig, idx) {
      var ids = getSampleGroupIds({
        depGroups: depGroups,
        groupConfig: groupConfig
      });
      sampleGroupIds[idx] = ids;
    });
  }
  return sampleGroupIds;
}
export function getDepGroups(_ref12) {
  var answers = _ref12.answers,
    _ref12$sampleByQuesti = _ref12.sampleByQuestion,
    sampleByQuestion = _ref12$sampleByQuesti === void 0 ? [] : _ref12$sampleByQuesti;
  var depGroups = [];
  // 题目组若配置显示逻辑，则根据依赖判断true/false，若未配置，置为true
  if (sampleByQuestion.length) {
    sampleByQuestion.forEach(function (sample, index) {
      var status = sample.dep && sample.dep.cons.length ? checkDepRule({
        answers: answers,
        dep: sample.dep
      }) : true;
      depGroups.push({
        index: index,
        status: status
      });
    });
  }
  return depGroups;
}
export function getGroupDepIds(_ref13) {
  var sampleConfig = _ref13.sampleConfig;
  var _sampleConfig$sampleB4 = sampleConfig.sampleByQuestion,
    sampleByQuestion = _sampleConfig$sampleB4 === void 0 ? [] : _sampleConfig$sampleB4,
    _sampleConfig$sampleB5 = sampleConfig.sampleByGroup,
    sampleByGroup = _sampleConfig$sampleB5 === void 0 ? [] : _sampleConfig$sampleB5;
  var groupDepIds = {};
  sampleByQuestion.forEach(function (sample, idx) {
    var _sample$dep, _sample$dep$cons;
    if ((sample === null || sample === void 0 ? void 0 : (_sample$dep = sample.dep) === null || _sample$dep === void 0 ? void 0 : (_sample$dep$cons = _sample$dep.cons) === null || _sample$dep$cons === void 0 ? void 0 : _sample$dep$cons.length) && sampleByGroup.length) {
      var conIds = sample.dep.cons.map(function (con) {
        return con.id.split('--matrix--')[0];
      });
      if (conIds === null || conIds === void 0 ? void 0 : conIds.length) {
        sampleByGroup.forEach(function (g, gIdx) {
          if (idx >= g.beginGroup && idx <= g.endGroup) {
            if (groupDepIds[gIdx]) {
              groupDepIds[gIdx] = groupDepIds[gIdx].concat(conIds);
            } else {
              groupDepIds[gIdx] = conIds;
            }
          }
        });
      }
    }
  });
  return groupDepIds;
}
export function checkGroupDepRule(_ref14) {
  var answers = _ref14.answers,
    sampleConfig = _ref14.sampleConfig,
    groupIndex = _ref14.groupIndex,
    sampleGroupIndex = _ref14.sampleGroupIndex,
    _ref14$answerKeys = _ref14.answerKeys,
    answerKeys = _ref14$answerKeys === void 0 ? [] : _ref14$answerKeys,
    _ref14$sampleGids = _ref14.sampleGids,
    sampleGids = _ref14$sampleGids === void 0 ? {} : _ref14$sampleGids;
  var _sampleConfig$sampleB6 = sampleConfig.sampleByQuestion,
    sampleByQuestion = _sampleConfig$sampleB6 === void 0 ? [] : _sampleConfig$sampleB6,
    _sampleConfig$sampleB7 = sampleConfig.sampleByGroup,
    sampleByGroup = _sampleConfig$sampleB7 === void 0 ? [] : _sampleConfig$sampleB7;
  var hasDepAnswerKey = false;
  var groupDepIds = getGroupDepIds({
    sampleConfig: sampleConfig
  });
  var depGroups = getDepGroups({
    answers: answers,
    sampleByQuestion: sampleByQuestion
  });
  if (!sampleByGroup.length || sampleGroupIndex === null || !groupDepIds[sampleGroupIndex]) {
    if (depGroups[groupIndex]) {
      return depGroups[groupIndex].status;
    }
  } else if (answerKeys.length) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
      for (var _iterator = answerKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var id = _step.value;
        if (groupDepIds[sampleGroupIndex] && groupDepIds[sampleGroupIndex].includes(id)) {
          hasDepAnswerKey = true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    if (hasDepAnswerKey) {
      globalSampleGids[sampleGroupIndex] = sampleGids[sampleGroupIndex];
    }
  }
  return globalSampleGids[sampleGroupIndex] && globalSampleGids[sampleGroupIndex].includes(groupIndex);
}
export var inputChecker = function inputChecker(text, restrictions) {
  var contentType = restrictions.contentType,
    maxWords = restrictions.maxWords,
    minWords = restrictions.minWords,
    openWordsRestriction = restrictions.openWordsRestriction;
  if (openWordsRestriction) {
    if (text.length > maxWords || text.length < minWords) {
      return "".concat(minWords, " - ").concat(maxWords);
    }
  }
  if (contentType) {
    switch (contentType) {
      case 'any':
        return true;
      case 'number':
        if (text.match(/^\d+(\.\d+)?$/)) return true;
        break;
      case 'chinese':
        if (text.match(/^[\u4e00-\u9fa5\s]+$/)) return true;
        break;
      case 'english':
        if (text.match(/^[a-zA-Z\s]+$/)) return true;
        break;
      case 'email':
        if (text.match(/^[a-zA-Z0-9.-_]+?@[a-zA-Z0-9-_]+?\.[a-zA-Z0-9-_.]+$/)) return true;
        break;
      case 'phone':
        if (text.match(/^1\d{10}$/)) {
          return true;
        }
        return getLocalText('ShortText.phoneNumber.wrong');
      case 'date':
        if (text.match(/^[\d\s-\\/.]+$/)) return true;
        break;
    }
    return contentType;
  }
  // 没有设置的规则就都是合法的
  return true;
};
export var getQuestionType = function getQuestionType(quest) {
  var questionType = {
    description: '',
    single: '单选题',
    singleSelect: '单选题',
    multi: '多选题',
    cascader: '级联选择',
    trueFalse: '判断题',
    sort: '排序题',
    short: '开放题',
    long: '开放题',
    scale: '量表题',
    nps: 'NPS题',
    singleMatrix: '矩阵单选题',
    multiMatrix: '矩阵多选题',
    scaleMatrix: '矩阵量表题',
    date: '日期选择',
    location: '省市区',
    upload: '附件题',
    name: '姓名',
    email: '邮箱',
    fillinShort: '单项填空',
    fillinLong: '简答题',
    other: '其他信息',
    order: '电商订单',
    nonScoreSingle: '信息单选',
    nonScoreMulti: '信息多选',
    nonScoreSingleSelect: '信息下拉',
    optionInput: '矩阵填空'
  };
  var type = quest.type;
  if (quest && quest.custom) {
    if (quest.type === 'scale' && quest.custom.styleType === 'nps') {
      type = 'nps';
    } else if (quest.type === 'matrix') {
      if (quest.custom.isScaleMatrix) {
        type = 'scaleMatrix';
      } else {
        type = quest.custom.isSingleMatrix ? 'singleMatrix' : 'multiMatrix';
      }
    }
  }
  return questionType[type] ? "\u3010".concat(questionType[type], "\u3011") : '';
};
export var getFirstQuestionJump = function getFirstQuestionJump(_ref15) {
  var questions = _ref15.questions;
  var jumpOver = false;
  if (questions && questions.length) {
    var custom = questions[0].custom;
    if (custom && custom.options && custom.options.length) {
      custom.options.forEach(function (option) {
        if (['end', 'nextEnd'].includes(option.jumpId)) {
          jumpOver = true;
          return false;
        }
      });
    }
  }
  return jumpOver;
};
export var resetAnwsers = function resetAnwsers(_ref16) {
  var _answers$question$id;
  var type = _ref16.type,
    question = _ref16.question,
    answers = _ref16.answers,
    _ref16$realShowOption = _ref16.realShowOptions,
    realShowOptions = _ref16$realShowOption === void 0 ? [] : _ref16$realShowOption,
    _ref16$realShowLines = _ref16.realShowLines,
    realShowLines = _ref16$realShowLines === void 0 ? [] : _ref16$realShowLines;
  var selected = (answers === null || answers === void 0 ? void 0 : (_answers$question$id = answers[question.id]) === null || _answers$question$id === void 0 ? void 0 : _answers$question$id.selected) || (type === 'matrix' ? {} : []);
  var optionIds = realShowOptions.map(function (o) {
    return o.id;
  }) || [];
  if (type === 'matrix') {
    if (selected && Object.keys(selected).length) {
      var lineIds = realShowLines.map(function (o) {
        return o.id;
      }) || [];
      Object.keys(selected).forEach(function (Lid) {
        if (lineIds.includes(Lid)) {
          selected[Lid] = (selected[Lid] || []).filter(function (id) {
            return optionIds.includes(id);
          });
        } else {
          delete selected[Lid];
        }
      });
    }
  } else if (selected.length) {
    selected = selected.filter(function (id) {
      return optionIds.includes(id);
    });
  }
  return selected;
};

// 选项分组
export function sampleOptions(_ref17) {
  var question = _ref17.question,
    answers = _ref17.answers;
  var _question$custom2 = question.custom,
    options = _question$custom2.options,
    _question$custom2$opt = _question$custom2.optionGroups,
    optGroupsList = _question$custom2$opt === void 0 ? [] : _question$custom2$opt,
    groupList = _question$custom2.sampleGroups;
  var newOptions = [];
  var _checkOptionGroups = checkOptionGroups({
      options: options,
      optionGroups: optGroupsList,
      sampleGroups: groupList
    }),
    optionGroups = _checkOptionGroups.optionGroups,
    sampleGroups = _checkOptionGroups.sampleGroups;
  var optGroups = getOptionIdx({
    options: options,
    optionGroups: optionGroups,
    answers: answers
  });
  var start = 0;
  optGroups.forEach(function (sample, groupIndex) {
    var sampleGroupIndex = null;
    if (sampleGroups.length) {
      sampleGroupIndex = sampleGroups.findIndex(function (g) {
        return groupIndex >= g.beginGroup && groupIndex <= g.endGroup;
      });
    }
    var beginIdx = sample.beginIdx,
      endIdx = sample.endIdx,
      isShuffle = sample.shuffle,
      isShow = sample.isShow; // 选项没设置分组
    if (start < beginIdx) {
      newOptions = newOptions.concat(options.slice(start, beginIdx));
    }
    start = endIdx + 1;
    var optionList = sampleOptGroups({
      options: options.slice(beginIdx, endIdx + 1),
      isShuffle: isShuffle,
      isShow: isShow,
      groupIndex: groupIndex,
      sampleGroupIndex: sampleGroupIndex
    });
    newOptions = newOptions.concat(optionList);
  });
  // 分组的选项最后的索引如果小于所有选项的长度，之后的选项都添加进去
  if (start < options.length) {
    newOptions = newOptions.concat(options.slice(start));
  }
  return newOptions;
}
// 选项组随机
export function getSampleGroupOpts(_ref18) {
  var options = _ref18.options,
    custom = _ref18.custom,
    answers = _ref18.answers;
  var optionGroups = custom.optionGroups,
    sampleGroups = custom.sampleGroups;
  var optGroups = getOptionIdx({
    options: options,
    optionGroups: optionGroups,
    answers: answers
  });
  var sampleIds = getSampleGids({
    optGroups: optGroups,
    sampleGroups: sampleGroups
  });
  var opts = [];
  var groupOpts = {};
  var groupIndex = null;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;
  try {
    for (var _iterator2 = options[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var opt = _step2.value;
      var gIdx = opt.groupIndex,
        sampleGroupIndex = opt.sampleGroupIndex; // 如果是有sampleGroupIndex及groupIndex，证明存在选项组随机，统一存储在groupOpts中，否则存储在opts中
      if (Number.isInteger(sampleGroupIndex) && Number.isInteger(gIdx)) {
        // 如果选项组在随机list中，则存到groupOpts中
        if (sampleIds.includes(gIdx)) {
          groupOpts[gIdx] = _toConsumableArray(groupOpts[gIdx] || []).concat([_objectSpread({}, opt)]);
          if (groupIndex !== gIdx) {
            groupIndex = gIdx;
            // 如果选项groupIndex连续，opts中用null占位
            opts.push(null);
          }
        }
      } else {
        opts.push(_objectSpread({}, opt));
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
  var realOpts = opts.reduce(function (pre, curr) {
    pre.push.apply(pre, _toConsumableArray(curr ? [curr] : groupOpts[sampleIds.shift()]));
    return pre;
  }, []);
  return realOpts;
}
export function getSampleGids(_ref19) {
  var optGroups = _ref19.optGroups,
    sampleGroups = _ref19.sampleGroups;
  var sampleIds = [];
  sampleGroups.forEach(function (g, idx) {
    var beginGroup = g.beginGroup,
      endGroup = g.endGroup,
      groupCount = g.groupCount;
    var options = optGroups.slice(beginGroup, endGroup + 1);
    var trueList = options.filter(function (item) {
      return item.isShow === true;
    });
    if (trueList.length > 0) {
      var groups = trueList.length > groupCount ? sampleSize(trueList, groupCount) : trueList;
      var ids = groups.map(function (g) {
        return g.gIdx;
      }).sort(function (a, b) {
        return a - b;
      });
      sampleIds = sampleIds.concat(g.shuffle ? shuffle(ids) : ids);
    }
  });
  return sampleIds;
}
export function sampleOptGroups(_ref20) {
  var options = _ref20.options,
    isShuffle = _ref20.isShuffle,
    isShow = _ref20.isShow,
    groupIndex = _ref20.groupIndex,
    sampleGroupIndex = _ref20.sampleGroupIndex;
  var sampleOpts = [];
  var noRandomOpts = []; // 固定位置的选项合集
  var optIdxs = [];
  options.forEach(function (opt, idx) {
    if (opt.noRandom) {
      noRandomOpts.push(idx);
    } else {
      optIdxs.push(idx);
    }
  });
  optIdxs.sort(function (a, b) {
    return a - b;
  });
  if (isShuffle) {
    optIdxs = shuffle(optIdxs);
  }
  // 如果选项位置固定，则按索引插入
  if (noRandomOpts.length) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;
    try {
      for (var _iterator3 = noRandomOpts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var index = _step3.value;
        optIdxs.splice(index, 0, index);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;
  try {
    for (var _iterator4 = optIdxs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var idx = _step4.value;
      sampleOpts.push(_objectSpread({}, options[idx], {
        isShow: isShow,
        groupIndex: groupIndex,
        sampleGroupIndex: sampleGroupIndex
      }));
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
  return sampleOpts;
}
export function getOptionIdx(_ref21) {
  var options = _ref21.options,
    optionGroups = _ref21.optionGroups,
    answers = _ref21.answers;
  var optGroups = [];
  var optionIndexMap = new Map(options.map(function (option, index) {
    return [option.id, index];
  }));
  if (optionGroups.length) {
    optionGroups.forEach(function (q, idx) {
      var beginIdx = optionIndexMap.get(q.beginId);
      var endIdx = optionIndexMap.get(q.endId);
      optGroups.push(_objectSpread({}, q, {
        beginIdx: beginIdx,
        endIdx: endIdx,
        gIdx: idx,
        isShow: q.dep ? checkDepRule({
          answers: answers,
          dep: q.dep
        }) : true
      }));
    });
  }
  return optGroups;
}
export function checkOptionGroups(_ref22) {
  var options = _ref22.options,
    optionGroups = _ref22.optionGroups,
    sampleGroups = _ref22.sampleGroups;
  var sampleValue = [];
  var groupsValue = sampleGroups;
  // 去掉选项顺序有问题的数据
  optionGroups.forEach(function (v, i) {
    // 开始选项索引
    var startIdx = options.findIndex(function (item) {
      return item.id === v.beginId;
    });
    // 结束选项索引
    var endIdx = options.findIndex(function (item) {
      return item.id === v.endId;
    });
    // 如果开始索引>结束索引，逻辑不成立，删除该选项组，随机置空
    if (startIdx < 0 || endIdx < 0 || startIdx > endIdx) {
      groupsValue = [];
      return false;
    }
    if (i > 0) {
      var preEndIdxs = []; // 前置选项组组结束索引集合
      var _loop4 = function _loop4(n) {
        var preEndI = options.findIndex(function (item) {
          return optionGroups[n] && item.id === optionGroups[n].endId;
        });
        preEndIdxs.push(preEndI);
      };
      for (var n = 0; n < i; n++) {
        _loop4(n);
      }
      preEndIdxs.sort(function (a, b) {
        return b - a;
      });
      // 如果当前选项组开始索引>前置选项组结束索引，逻辑成立，否则删除改选项组，组随机置空
      if (preEndIdxs.length && startIdx > preEndIdxs[0]) {
        sampleValue.push(v);
      } else {
        groupsValue = [];
      }
    } else {
      sampleValue.push(v);
    }
  });
  return {
    optionGroups: sampleValue,
    sampleGroups: groupsValue
  };
}
export function getMultiChoiceOptions(_ref23) {
  var _custom$optionGroups;
  var opts = _ref23.options,
    custom = _ref23.custom;
  var options = custom.options,
    optionGroups = custom.optionGroups,
    sampleGroups = custom.sampleGroups;
  var newOptions = opts ? JSON.parse(JSON.stringify(opts)) : [];
  if (newOptions.length && custom.group && (custom === null || custom === void 0 ? void 0 : (_custom$optionGroups = custom.optionGroups) === null || _custom$optionGroups === void 0 ? void 0 : _custom$optionGroups.length)) {
    var gidx = null;
    var i = -1;
    var _checkOptionGroups2 = checkOptionGroups({
        options: options,
        optionGroups: optionGroups,
        sampleGroups: sampleGroups
      }),
      groups = _checkOptionGroups2.optionGroups;
    var groupOpts = newOptions.reduce(function (acc, cur, index) {
      var groupIndex = cur.groupIndex;
      if (groupIndex !== undefined) {
        if (groupIndex !== -1) {
          var _ref24 = groups[groupIndex] || {},
            name = _ref24.name,
            showGroupName = _ref24.showGroupName;
          if (gidx === groupIndex) {
            acc[i] = {
              name: name,
              showGroupName: showGroupName,
              options: _toConsumableArray(acc[i].options || []).concat([cur])
            };
          } else {
            gidx = groupIndex;
            acc[i + 1] = {
              name: name,
              showGroupName: showGroupName,
              options: [cur]
            };
            i++;
          }
        } else {
          acc[i + 1] = {
            name: '',
            showGroupName: false,
            options: [cur]
          };
          i++;
        }
      } else {
        acc[i + 1] = {
          name: '',
          showGroupName: false,
          options: [cur]
        };
        i++;
      }
      return acc;
    }, []);
    newOptions = groupOpts;
  }
  return newOptions;
}